<template lang="pug">
.panel-page-white.body-1
  .panel-white.mx-auto

    h1.dashboard-header Dashboard

    .mt-5(v-show="displayPasswordExpirationAlert")
      PasswordExpirationAlert(
        :daysUntilPasswordExpires="daysUntilPasswordExpires"
        @dismissPasswordExpirationAlert="passwordExpirationAlertDismissed = true",
      )

    .dashboard-row.mt-5(v-if="$auth.sworn()")
      h4 Shortcuts

    .dashboard-row(v-if="$auth.sworn()")
      DashboardShortcut(background-color="#158287"
        heading="Person Search"
        :to="{name: 'person_search'}")
        template(slot="icon")
          img.dashboard-image(src="../assets/img/dashboard_person_search.svg")

      DashboardShortcut(background-color="#491654"
        heading="My Search History"
        :to="{name: 'my_searches'}")
        template(slot="icon")
          img.dashboard-image(src="../assets/img/dashboard_my_searches.svg")

      DashboardShortcut(background-color="#567c18"
        heading="My Person Watches"
        :to="{name: 'watch_list'}")
        template(slot="icon")
          img.dashboard-image(src="../assets/img/dashboard_my_watches.svg")

      DashboardShortcut(background-color="#0071bc"
        heading="Geo-Activity Report"
        :to="{name: 'geo_activity_search'}")
        template(slot="icon")
          img.dashboard-image(src="../assets/img/dashboard_reports.svg")

    div
      .dashboard-row.panel-row.mt-5
        div.mr-3
          h4 Announcements
        div
          h4 NPLEx State Map
    div
      .dashboard-row.panel-row
        .dashboard-panel.mr-3
          strong {{ announcement[0] }}
          p(v-html="announcement[1]")
        .dashboard-panel
          img.img-fluid(src="../assets/img/nplex_map.png")
</template>

<script>
import { differenceInDays, parse } from 'date-fns/esm'
import { mapState } from 'vuex'
import store from '@/store'
import DashboardShortcut from '@/components/DashboardShortcut'
import PasswordExpirationAlert from '@/components/PasswordExpirationAlert'

export default {
  name: 'Dashboard',
  components: {
    DashboardShortcut,
    PasswordExpirationAlert,
  },
  computed: {
    ...mapState(['announcement']),
    daysUntilPasswordExpires() {
      const passExpDate = store.state.account.passExpDt
      if (passExpDate && passExpDate.length > 0) {
        const parsedPassExpDate = parse(passExpDate, "MM/dd/yyyy hh:mm aa", new Date());
        return differenceInDays(parsedPassExpDate, new Date());
      }
      return null;
    },
    displayPasswordExpirationAlert() {
      return this.daysUntilPasswordExpires && this.daysUntilPasswordExpires < 6 && !this.passwordExpirationAlertDismissed;
    }
  },
  data() {
    return {
      passwordExpirationAlertDismissed: false
    }
  },
}
</script>

<style lang="scss" scoped>
.dashboard-row {
  display: flex;

  div,
  h4 {
    flex-grow: 1;
    max-width: 50%;
  }
}

.dashboard-image {
  width: 60px;
}

.dashboard-panel {
  border: 1px solid #e6e6e6;
  padding: 1rem;
}

.dashboard-shortcut:last-child {
  margin-right: 0;
}

.dashboard-header {
  margin-bottom: 0;
}

.dashboard-row.panel-row {
  div {
    width: 100%;
  }
}
</style>
